import { createElement } from "react";
import { fromFlatEntries } from "../Feliz.MaterialUI.5.13.7-alpha.8/Flatten.fs.js";

export const MuiXHelpers_reactElement = createElement;

export const MuiXHelpers_reactElementTag = createElement;

export function MuiXHelpers_createElement(el, properties) {
    return MuiXHelpers_reactElement(el, fromFlatEntries(properties));
}

export function MuiXHelpers_createElementTag(tag, properties) {
    return MuiXHelpers_reactElementTag(tag, fromFlatEntries(properties));
}

